module.exports = __webpack_public_path__ + "img/5.b112b172.webp";